// Libraries
var React = require('react');

// Assets
var deleteIcon = require('images/close-spurs-mid-purple.svg');

const HashtagItem = props => {
	return (
		<span className="Hashtag__tag">
			<a className="link" href={props.tag.url}>
				{props.tag.hashtag}
			</a>
			<button className="remove" data-id={props.tag.id} onClick={props.handleRemove} type="type"><img src={deleteIcon} alt="Delete hashtag" /></button>
		</span>
	);
};

module.exports = HashtagItem;


// WEBPACK FOOTER //
// ./src/components/HashtagModule/HashtagItem.js